<template>
    <main id="otp-wrapper">
        <div id="otppage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    { title: 'Beranda', url: '/', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div class="row">
                    <div class="col">
                        <a href="#">
                            <img src="/images/arrow-back.png" alt="img-arrow" id="img-arrow">
                            <span class="px-2 text-back">Kembali</span>
                        </a>
                    </div>
                </div>
                <br>
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div id="card-verifikasi" class="card mb-4">
                            <div class="card-body">
                                <h3 class="title">Masukkan Kode Verifikasi</h3>
                                <div class="row">
                                    <div class="col">
                                        <a class="text-normal color-3f">OTP akan dikirimkan ke</a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <a class="text-phone color-3f">(+62) 85662344425</a>
                                    </div>
                                </div>
                                <br><br><br>
                                <form action="#">
                                    <div class="form-group row">
                                        <div class="col">
                                            <input type="text" class="form-control">
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control">
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control">
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control">
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control">
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="form-group row">
                                        <div class="col">
                                            <a class="btn" id="btn-login">Login</a>
                                        </div>
                                    </div>
                                    <div class="form-group row text-center" v-if="isSend">
                                        <div class="col">
                                            Tidak menerima kode ? <a href="#" id="btn-link">Kirim ulang</a>
                                        </div>
                                    </div>
                                    <div class="form-group row text-center" v-else>
                                        <div class="col">
                                            Mohon tunggu <b>30</b> detik untuk kirim ulang.
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";

export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            mobile: false,
            isSend: true
        };
    },
    created() {
        this.mobile = isMobile;
    },
    methods: {}
};
</script>

<style scoped lang="scss">
#otppage{
    background: #000000;
    #card-verifikasi{
        background: #FFFFFF;
        border-radius: 10px;
        /* font-family: Inter; */
    }
    .title{
        color: #000000;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 1rem;
    }
    .text-normal{
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 24px;
    }
    .color-3f{
        color: #3F3F3F;
    }
    .text-phone{
        font-weight: 600;
        font-size: 15px;
        line-height: 25px;
    }
    input {
        outline: 0;
        border-width: 0 0 2px !important;
        border-color: #B4B4B4 !important;
        text-align: center;
    }
    .btn{
        width:100%;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
    }
    #btn-login{
        background: #E61B33;
        color: #FFFFFF;
        border-radius: 10px;
    }
    #btn-link{
        color: #727272;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
    }
    #img-arrow{
        max-width: 20px;
    }
    .text-back{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
    }
}
</style>